import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { Button } from 'web-ui-components/lib/atoms/buttons';

export const AddMoreButton = ({ onClick, isDisabled, title }) => (
	<Button
		onClick={onClick}
		disabled={isDisabled}
		role="button"
		className={classNames('add-payment', 'c-a-button', 'c-a-button--width-flush', {
			'is-disabled': isDisabled,
		})}
		data-test-id="add-more-button"
	>
		<Icon iconType="PlusOutlineLarge" />
		<span className="c-a-button__title">{title}</span>
	</Button>
);

AddMoreButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	isDisabled: PropTypes.bool,
};
export default AddMoreButton;
